<div class="service-result-columns">
  <div class="columns-chooser-toolbar">
    <div>
      <button (click)="onApplyClick()" class="iv-flat-button" style="margin-left: 0px;">Apply</button>
      <button (click)="onSaveDefaultClick()" [disabled]="saveDefaultDisabled" class="iv-flat-button">Save as default</button>
    </div>
    <div>
      <button (click)="onSelectAllClick()" class="iv-inline-button">Select all</button>
      <button (click)="onUnselectAllClick()" class="iv-inline-button">Unselect all</button>
    </div>
  </div>

  <div *ngIf="needRestoreDefaultColumns">
    <iv-live-image-button
      (buttonClicked)="restoreDefaultColumns.emit()"
      statistic
      statisticElementName="Click Option Monitor restore default columns"
      class="with-caption"
      style="margin-left: 10px; margin-top: -4px; overflow: visible;"
    >
      <img
        src="data:image/png;base64,
  iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAABHNCSVQICAgIfAhkiAAAAAlwSFlzAAABuwAAAbsBOuzj4gAAABl0RVh0U29mdHdhcmUAd3d3Lmlua3NjYXBlLm9yZ5vuPBoAAAKUSURBVEiJ3dVPiFVlGMfxz3vOnZoMXShRTCQjQX9cRKCIw9hCaCEtklG7bSJoNREZVG4ikZcRXBQIKQUTgVCtbo6WQhAEQszIaMGsElpUKlMa0URRDHrvOW+Lud47d/7dmNrUAwdenvN7v7/nfV7Oc/ivR+iqqNVy+aVBwiCpT1IKvheyC4YOTQpSS3suVvy8rkf1ldnuBmfjGnUvSA7g7mVUl6XwhvLhd1WrhZNxTLDTrH7PxN+XN6gd3iQvPsYjSJiQwhlMCyqk+7EL25qMKXllt6JxGluo9Nt78ApUFsPjRnkxjj58JWUv2nfowhJlRKdHtijL4xhQNCaQLRR1JkZHe+TOok9Qc8f6HcvA56JefoOjuIL7cO9CSecJNlzb32zLpN71z3ripRvLwiF3BPtXkrQNYswELyMJ2fNd4ZD5UOk2C+8yZH+0lq3kRyOPycovMGFv3NEV/jejfQdZerS5+vzfgjO/RSH1SQjh61XTTsRea8Nzeiqn7H79p06Dhrfk4bJG+mTVBmvDkJDeUdQ34rVOg2q8jtFVwyGkzc3F9K3Uog/jH8YuUKSplmfrVe3IXfKbb3dW5IbguKF4sSv61MiAVJ7HVXti/60h2G5RXq7BUx2bEkozWNng02O3m505NrcnHJ0/YRfPonb1l/CqwviK8BOx1+zMB9iKKRtSRxeWuoMfMC3ZLDko98Cy8LG43ToT2Nfc96SdsTFfstQJrivskTuDQXxpLF7EZ4RvhRQkD+Jxc+MaJhWeVo3TC2Ftg0rPjEbjN3ynGq86F7f6NQxL6QC2zz3JvP8XXJPCYb/c857h4fpSh+wcUu+/eafeP+uq8WYrlwQn44DMNskmQUb4URnGpYfOq1aLpcD/n/gLnyXMKF/NV8AAAAAASUVORK5CYII=
  "
      >
      <div style="white-space: nowrap; margin-left: 3px;">
        Restore default columns
      </div>
    </iv-live-image-button>
  </div>

  <div class="columns-search-toolbar">
    <input #searchInput (input)="filterColumns($event.target.value)" class="column-search" placeholder="Search...">
    <button (click)="clearSearch(searchInput)" class="clear-search">
      <div class='square-content'>
        <div>
          <span class="material-icons">&#xE5CD;</span>
        </div>
      </div>
    </button>
  </div>
  <div class="service-result-columns_container">
    <dx-scroll-view
      [class.mac]="isMac"
      [height]="'100%'"
      [width]="'100%'"
      direction="Both">
      <div *ngIf="uniqueColumns.length > 0" class="unique-columns">
        <div>
          <ng-container *ngFor="let column of uniqueColumns">
            <ng-container *ngTemplateOutlet="followingpost;context:{
            name: column.caption,
            mode: column.mode,
            regionId: regionId,
            dataField: column.dataField}"></ng-container>
          </ng-container>
        </div>
      </div>
    </dx-scroll-view>
  </div>
</div>

<ng-template #followingpost let-dataField="dataField" let-mode="mode" let-name="name" let-regionId="regionId">
  <div [class.disabled]="regionId !== 1 && mode === 'rt'" class="column-container">
    <div>
      {{name}}
    </div>
    <span
      (click)="toggleColumn(dataField)"
      [class.active]="isColumnVisible(dataField)"
      class="iv-switcher"
    ></span>
  </div>
</ng-template>
